import { collection, getDocs, onSnapshot } from "firebase/firestore"
import { db } from "../lib/firebase"


export const getUserTags = (userUid) => {
  return getDocs(collection(db, 'users', userUid, 'moments'))
}

export const subscribeToUserTags = (userUid, callback) => {
  return onSnapshot(collection(db, 'users', userUid, 'moments'), callback)
}
